{
  "familyId": "TOPO-NL-PROV",
  "questions": [
    {
      "id": "TOPO-NL-PROV-001",
      "familyId": "TOPO-NL-PROV",
      "module": "Topo",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_provincies",
      "questionType": "multiple_choice",
      "question": "Een reisleider vraagt: 'Wat is de hoofdstad van de provincie Gelderland?'",
      "options": ["Arnhem", "Nijmegen", "Apeldoorn", "Ede"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Provinciale hoofdsteden",
            "content": "Elke provincie heeft een hoofdstad waar het provinciebestuur zit. Arnhem is de hoofdstad van Gelderland. Nijmegen, Apeldoorn en Ede zijn grote steden in Gelderland, maar niet de hoofdstad.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "province_capital_match",
      "variantIndex": 1,
      "citoDifficulty": 0.20,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Arnhem is de hoofdstad van de provincie Gelderland. Daar zit het provinciebestuur. Nijmegen, Apeldoorn en Ede zijn grote steden in Gelderland, maar niet de hoofdstad. Ezelsbruggetje: Arnhem begint met A, net als 'administratie' — daar zit het bestuur.",
        "solutionSteps": [
          "Gelderland is een grote provincie in het oosten van Nederland",
          "De hoofdstad is Arnhem (daar zit het provinciebestuur)",
          "Ezelsbruggetje: Arnhem = Administratie"
        ],
        "distractorExplanations": {
          "0": "Goed! Arnhem is de hoofdstad van de provincie Gelderland.",
          "1": "Je dacht waarschijnlijk dat de grootste of bekendste stad de hoofdstad is. Maar Nijmegen is een grote stad in Gelderland, niet de hoofdstad. De hoofdstad is waar het provinciebestuur zit: Arnhem. Onthoud: de hoofdstad is niet altijd de grootste stad.",
          "2": "Je dacht waarschijnlijk dat Apeldoorn de hoofdstad is. Maar Apeldoorn is bekend van Paleis Het Loo, niet als provinciale hoofdstad. De hoofdstad van Gelderland is Arnhem.",
          "3": "Je dacht waarschijnlijk dat Ede de hoofdstad is. Maar Ede ligt wel in Gelderland, maar is niet de hoofdstad. De hoofdstad is Arnhem."
        }
      }
    },
    {
      "id": "TOPO-NL-PROV-002",
      "familyId": "TOPO-NL-PROV",
      "module": "Topo",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_provincies",
      "questionType": "multiple_choice",
      "question": "Een cartograaf tekent een kaart. Welke provincie grenst aan Duitsland én aan de Noordzee?",
      "options": ["Groningen", "Friesland", "Zuid-Holland", "Utrecht"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Grenzen van Groningen",
            "content": "Groningen ligt in het noordoosten van Nederland. Het grenst aan Duitsland (in het oosten) én aan de Noordzee (in het noorden). Geen andere provincie heeft beide grenzen.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "province_border_reasoning",
      "variantIndex": 2,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "De cartograaf kijkt op de kaart: welke provincie ligt in een hoek waar zowel land (Duitsland) als zee (Noordzee) grenst? Duitsland ligt in het oosten, de Noordzee in het noorden en westen. Alleen Groningen ligt in het noordoosten en raakt dus beide.",
        "solutionSteps": [
          "Duitsland ligt in het oosten van Nederland",
          "De Noordzee ligt in het noorden en westen",
          "Welke provincie raakt beide? Groningen (noordoost)",
          "Check: Friesland raakt de zee maar niet Duitsland ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! Groningen grenst aan zowel Duitsland (oost) als de Noordzee (noord).",
          "1": "Je dacht waarschijnlijk dat Friesland ook aan Duitsland grenst. Maar Friesland grenst wel aan de Noordzee (en de Waddenzee), maar niet aan Duitsland. Groningen ligt oostelijker en raakt wél de Duitse grens. Onthoud: Friesland = zee, Groningen = zee + Duitsland.",
          "2": "Je dacht waarschijnlijk dat Zuid-Holland aan Duitsland grenst. Maar Zuid-Holland ligt aan de Noordzee, maar helemaal niet in de buurt van Duitsland. Onthoud: Duitsland grenst aan de oostelijke provincies.",
          "3": "Je dacht waarschijnlijk dat Utrecht aan de zee of Duitsland grenst. Maar Utrecht ligt midden in Nederland en grenst aan geen van beide. Onthoud: Utrecht is een binnenlandse provincie."
        }
      }
    },
    {
      "id": "TOPO-NL-PROV-003",
      "familyId": "TOPO-NL-PROV",
      "module": "Topo",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_provincies",
      "questionType": "multiple_choice",
      "question": "Een postbode moet post bezorgen bij het provinciebestuur van Noord-Holland. Naar welke stad moet hij?",
      "options": ["Haarlem", "Amsterdam", "Alkmaar", "Den Helder"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Hoofdstad vs. grootste stad",
            "content": "Let op: Amsterdam is de hoofdstad van Nederland, maar Haarlem is de hoofdstad van de provincie Noord-Holland. Het provinciebestuur zit in Haarlem. Dit is een bekende strikvraag!",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "province_capital_trick",
      "variantIndex": 3,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.69,
      "feedback": {
        "explanationText": "De postbode moet naar Haarlem. Amsterdam is de hoofdstad van heel Nederland, maar de provinciale hoofdstad van Noord-Holland is Haarlem — daar zit het provinciebestuur. Dit is de bekendste strikvraag bij topografie!",
        "solutionSteps": [
          "Amsterdam = hoofdstad van Nederland",
          "Haarlem = hoofdstad van de provincie Noord-Holland",
          "Het provinciebestuur zit in Haarlem",
          "De postbode moet naar Haarlem"
        ],
        "distractorExplanations": {
          "0": "Goed! Haarlem is de hoofdstad van de provincie Noord-Holland.",
          "1": "Je dacht waarschijnlijk dat Amsterdam de provinciale hoofdstad is. Maar Amsterdam is de hoofdstad van Nederland, niet van de provincie Noord-Holland. De provinciale hoofdstad is Haarlem. Onthoud: dit is de bekendste strikvraag bij topografie!",
          "2": "Je dacht waarschijnlijk dat Alkmaar de hoofdstad is. Maar Alkmaar is een stad in Noord-Holland (bekend van de kaasmarkt), niet de hoofdstad. De hoofdstad is Haarlem.",
          "3": "Je dacht waarschijnlijk dat Den Helder de hoofdstad is. Maar Den Helder ligt aan de punt van Noord-Holland en is niet de hoofdstad. De hoofdstad is Haarlem."
        }
      }
    },
    {
      "id": "TOPO-NL-PROV-004",
      "familyId": "TOPO-NL-PROV",
      "module": "Topo",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_provincies",
      "questionType": "multiple_choice",
      "question": "Hoeveel provincies heeft Nederland?",
      "options": ["12", "10", "11", "14"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Provincies van Nederland",
            "content": "Nederland heeft 12 provincies. Tel ze per regio: Noord (Groningen, Friesland, Drenthe), Oost (Overijssel, Flevoland, Gelderland), West (Utrecht, Noord-Holland, Zuid-Holland), Zuid (Zeeland, Noord-Brabant, Limburg).",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "province_count",
      "variantIndex": 4,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Nederland heeft 12 provincies. Tel ze per regio: Noord (3): Groningen, Friesland, Drenthe. Oost (3): Overijssel, Flevoland, Gelderland. West (3): Utrecht, Noord-Holland, Zuid-Holland. Zuid (3): Zeeland, Noord-Brabant, Limburg. Totaal: 3 + 3 + 3 + 3 = 12.",
        "solutionSteps": [
          "Noord (3): Groningen, Friesland, Drenthe",
          "Oost (3): Overijssel, Flevoland, Gelderland",
          "West (3): Utrecht, Noord-Holland, Zuid-Holland",
          "Zuid (3): Zeeland, Noord-Brabant, Limburg",
          "Totaal: 3 + 3 + 3 + 3 = 12"
        ],
        "distractorExplanations": {
          "0": "Goed! Nederland heeft 12 provincies.",
          "1": "Je dacht waarschijnlijk dat het er 10 zijn. Dan vergeet je waarschijnlijk 2 provincies — vaak Flevoland (de jongste) en een andere. Tel ze per regio: noord, oost, west, zuid — elk 3 = 12. Onthoud: 4 × 3 = 12.",
          "2": "Je dacht waarschijnlijk dat het er 11 zijn. Dan vergeet je waarschijnlijk één provincie — vaak Flevoland, omdat het de jongste is (pas sinds 1986). Nederland heeft 12 provincies. Onthoud: 4 × 3 = 12.",
          "3": "Je dacht waarschijnlijk dat het er 14 zijn. Misschien tel je grote steden als aparte provincies mee. Maar Nederland heeft 12 provincies, niet meer. Onthoud: 4 × 3 = 12."
        }
      }
    },
    {
      "id": "TOPO-NL-PROV-005",
      "familyId": "TOPO-NL-PROV",
      "module": "Topo",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_provincies",
      "questionType": "multiple_choice",
      "question": "Een geschiedenisleraar vraagt: 'Welke provincie is de jongste van Nederland?'",
      "options": ["Flevoland", "Drenthe", "Zeeland", "Utrecht"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Flevoland: jongste provincie",
            "content": "Flevoland is de jongste provincie van Nederland. Het land is aangelegd door inpoldering van de Zuiderzee. Flevoland werd in 1986 officieel een provincie.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "province_flevoland",
      "variantIndex": 5,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Flevoland is de jongste provincie van Nederland. Het land is aangelegd door inpoldering van de Zuiderzee (het IJsselmeer). Flevoland werd pas in 1986 officieel een provincie. Alle andere provincies bestaan al eeuwen.",
        "solutionSteps": [
          "Welke provincie is er niet altijd geweest?",
          "Flevoland is aangelegd door inpoldering van de Zuiderzee",
          "Flevoland werd in 1986 officieel een provincie",
          "Alle andere provincies bestaan al eeuwen → Flevoland is de jongste"
        ],
        "distractorExplanations": {
          "0": "Goed! Flevoland is de jongste provincie, opgericht in 1986 na inpoldering.",
          "1": "Je dacht waarschijnlijk dat Drenthe jong is omdat het dunbevolkt is. Maar Drenthe is juist een van de oudste bewoonde gebieden van Nederland, met hunebedden uit de prehistorie. De jongste provincie is Flevoland (1986). Onthoud: dunbevolkt ≠ jong.",
          "2": "Je dacht waarschijnlijk dat Zeeland jong is. Maar Zeeland bestaat al eeuwen en dankt zijn naam aan de strijd tegen de zee. De jongste provincie is Flevoland (1986). Onthoud: Zeeland is oud, Flevoland is nieuw.",
          "3": "Je dacht waarschijnlijk dat Utrecht jong is. Maar Utrecht is een van de oudste provincies, met een geschiedenis tot de Romeinse tijd. De jongste provincie is Flevoland (1986). Onthoud: Utrecht is oud, Flevoland is nieuw."
        }
      }
    }
  ]
}